import ActivityLinkItem from '@/shared/ActivityLinkItem/ActivityLinkItem';
import { StyledLibraryActivitiesList } from './LibraryActivitiesList.styled';
import LanguageSelector from '@/shared/LanguageSelector/LanguageSelector';
import SearchInput from '@/shared/SearchInput/SearchInput';
import useLibraryActivitiesList from './useLibraryActivitiesList.hook';
import { Button, Empty, Space } from 'antd';
import LibraryLevelFilter from '../../LibraryLevelFilter/LibraryLevelFilter';

export default function LibraryActivitiesList({
  title,
  activities,
  urlPrefix,
  isPublic,
  allowFreeLabel,
  buttons = null,
  showLevelFilter,
}) {
  const { state, actions } = useLibraryActivitiesList({ activities });
  return (
    <StyledLibraryActivitiesList>
      <div className="header">
        <div className="first-row">{title}</div>
        {showLevelFilter && (
          <LibraryLevelFilter fullText="All levels" size="small" />
        )}
        <div className="second-row">
          {isPublic ? <LanguageSelector /> : null}
          <SearchInput
            placeholder="Search"
            value={state.searchText}
            onChange={actions.setSearchText}
            allowClear
          />
          {buttons}
        </div>
      </div>
      {state.filteredActivities.length == 0 ? (
        <div className="empty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              state.canReset ? (
                <Space direction="vertical">
                  <span>There is no content for this search</span>
                  <Button onClick={() => actions.reset()}>Clear filters</Button>
                </Space>
              ) : (
                'There is no content here yet'
              )
            }
          />
        </div>
      ) : (
        <div className="activities">
          {state.filteredActivities.map((activity) => (
            <ActivityLinkItem
              activity={activity}
              key={activity.id}
              urlPrefix={urlPrefix}
              allowFreeLabel={allowFreeLabel}
            />
          ))}
        </div>
      )}
    </StyledLibraryActivitiesList>
  );
}
